function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M37.97,17.38c1.99,4.91,5.81,8.33,9.33,11.47,3.39,3.03,6.59,5.88,8.43,10.02,3.16,7.11,3.04,13.62-.35,18.84-3.24,4.98-9.1,8.08-15.31,8.08s-11.28-2.9-14.87-8.16c-3.19-4.67-4.13-12.5-2.19-17.52.39,5.53,1.8,9.65,4.21,12.32,2.09,2.31,4.87,3.53,8.04,3.53,2.22,0,4.54-.58,7.1-1.77,4.83-2.25,6.38-5.46,6.84-7.77,1.21-6.13-3.84-11.62-7.54-15.63-.89-.96-1.99-2.16-2.29-2.65-1.75-2.83-2.3-7.56-1.4-10.77M41.27,9.21c-9.92,0-10.5,14.56-6.15,21.57,2.52,4.06,15.89,13.87,5.13,18.88-1.95.91-3.6,1.31-4.99,1.31-8.07,0-7.74-13.35-7.02-20.56-13.3,1.4-13.56,20.69-7.17,30.05,4.91,7.19,12.03,10.34,19,10.34,14.82,0,29.02-14.19,20.23-33.95-5.39-12.11-19.32-14.59-18.67-27.63-.12,0-.24,0-.35,0h0Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/Popularity-inactive.2b887a40.svg";
export { SvgComponent as ReactComponent };